export default "__VITE_PUBLIC_ASSET__8dad74b0__"